import type {
  GetAccessTokenSilentlyType,
  GetAccessTokenWithPopupType
} from '@/types/transcriptionSessionTypes';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

const AUTH_PARAMS = {
  authorizationParams: {
    audience: import.meta.env.VITE_API_AUTH0_AUDIENCE
  }
};

const needsInteractiveToken = (error: any) => {
  if (!error) return false;
  const code = error.error || error.code;
  return (
    code === 'consent_required' ||
    code === 'login_required' ||
    code === 'interaction_required'
  );
};

export const fetchCompanyLogoBlob = async (
  userId: string,
  getAccessTokenSilently: GetAccessTokenSilentlyType,
  getAccessTokenWithPopup?: GetAccessTokenWithPopupType,
  cacheBust = false
): Promise<Blob | null> => {
  if (!userId) return null;

  let token: string;
  try {
    token = await getAccessTokenSilently(AUTH_PARAMS);
  } catch (error: any) {
    if (getAccessTokenWithPopup && needsInteractiveToken(error)) {
      const popupToken = await getAccessTokenWithPopup(AUTH_PARAMS);
      if (!popupToken) {
        return null;
      }
      token = popupToken;
    } else {
      throw error;
    }
  }

  const url = `${API_BASE_URL}/companies/logo${cacheBust ? `?v=${Date.now()}` : ''}`;
  const resp = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'X-User-Id': userId
    }
  });

  if (!resp.ok) {
    return null;
  }

  return await resp.blob();
};

export const fetchCompanyLogoBlobById = async (
  userId: string,
  companyId: string,
  getAccessTokenSilently: GetAccessTokenSilentlyType,
  getAccessTokenWithPopup?: GetAccessTokenWithPopupType,
  cacheBust = false
): Promise<Blob | null> => {
  if (!userId || !companyId) return null;

  let token: string;
  try {
    token = await getAccessTokenSilently(AUTH_PARAMS);
  } catch (error: any) {
    if (getAccessTokenWithPopup && needsInteractiveToken(error)) {
      const popupToken = await getAccessTokenWithPopup(AUTH_PARAMS);
      if (!popupToken) {
        return null;
      }
      token = popupToken;
    } else {
      throw error;
    }
  }

  const url = `${API_BASE_URL}/companies/${companyId}/logo${cacheBust ? `?v=${Date.now()}` : ''}`;
  const resp = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'X-User-Id': userId
    }
  });

  if (!resp.ok) {
    return null;
  }

  return await resp.blob();
};

